"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Price", {
  enumerable: true,
  get: function get() {
    return _price["default"];
  }
});
Object.defineProperty(exports, "formatPrice", {
  enumerable: true,
  get: function get() {
    return _fuseUtils.formatPrice;
  }
});
var _fuseUtils = require("@tvg/fuse-utils");
var _price = _interopRequireDefault(require("./price"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }